import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { Accordion } from "@material-ui/core";
import { AccordionSummary } from "@material-ui/core";
import { AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import PropTypes from "prop-types";
import { AppBar } from "@material-ui/core";
import { Tabs } from "@material-ui/core";
import { Tab } from "@material-ui/core";
import { Box } from "@material-ui/core";
import MenuBookOutlinedIcon from "@material-ui/icons/MenuBookOutlined";
import descimg from "../../../../../../ebusHomePics/tttt.png";
import styled from "styled-components";

const FontSizeH2 = styled.div`
  font-size: calc(1.3rem + .6vw);
`;
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(21),
    fontWeight: theme.typography.fontWeightRegular,
    // fontSize:theme.typography.fontSize=17,
  },
  des: {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: "2",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MainPageFaq = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className="container">
      <div className="d-flex container-fluid mx-auto">
        <FontSizeH2 style={{ marginTop: "35px" }}>
          <b>سوالات متداول</b>
        </FontSizeH2>
      </div>
      <div className={`${classes.root} `}>
        <TabPanel value={value} index={0}>
          <Accordion className="mt-2 mb-5 p-1" style={{ boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              //   id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                چه زمانی میتوانم اقدام به خرید بلیط کنم؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                شما می توانید از 15 روز قبل از تاریخ حرکت تا 10 دقیقه مانده به
                شروع حرکت اتوبوس بلیط خود را خریداری نمایید.
                <br />
                ما در ایباس خرید زودهنگام بلیط با قیمت های مناسب تر را به شما
                پیشنهاد میکنیم.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-1 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                آیا می توانم برای فرد دیگری بلیط خریداری کنم؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                بله,می توانید برای یک دوست بلیط رزرو کنید. کافی است هنگام رزرو
                نام دوست خود را وارد کرده و آدرس ایمیل یا شماره تلفن ایشان را
                وارد کنید تا بلیط را مستقیماً دریافت کنند. <br />
                از طرف دیگر ,می توانید بلیط را به دوست خود ارسال کنید. دوست شما
                می تواند شماره رزرو را در اپلیکیشن ایباس وارد کرده و بلیط را
                مستقیماً از طریق تلفن خود دریافت کند.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-1 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                امکان خرید بلیط اتوبوس به صورت افلاین وجود دارد؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                در صورت وجود صندلی خالی ,می توانید از راننده اتوبوس بلیط تهیه
                کنید. هنگام خرید بلیط از راننده اتوبوس ,امتیازات شما قابل
                استفاده نیستند. رسید پرداخت هم بلیط شما است و هم تأیید رزرو شما.
                لطفاً توجه داشته باشید که بلیط های زود هنگام ,پیشنهادات ویژه و
                تخفیف های گروهی فقط به صورت آنلاین در دسترس است.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-1 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                شرایط خرید بلیط گروهی اتوبوس چگونه است؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                اگر تعداد بلیط های شما از 8 عدد بیشتر شود ,می توانید بلیط
                سفرهای گروهی را از طریق برنامه و وب سایت ما رزرو کنید. برای خرید
                بیش از 8 بلیط با کارشناسان ما تماس بگیرید. علاوه بر این,می
                توانید با استفاده از سیستم دربستی ایباس یک اتوبوس خصوصی همراه با
                راننده اجاره کنید. تقریباً هرگونه درخواست خاصی امکان پذیر است.
                بلافاصله قیمت به شما نشان داده می شود,که باعث رزرو سریع و آسان
                اتوبوس شما خواهد بود. استرداد رایگان بلیط اتوبوس تا 7 روز قبل از تاریخ سفر
                امکان پذیر است.{" "}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-1 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                سفر اتوبوسی به همراه کودکان چگونه است؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                ایمنی مسافران کودک برای ما اهمیت ویژه ای دارد. بنابراین ،
                لطفاً به موارد زیر توجه کنید:
                <br />
                کودکان 2 تا 6 سال باید در صندلی کودک بنشینند که با کمربند ایمنی
                مخصوص محافظت شوند. <br />
                کودکان و نوجوانان زیر 18 سال باید به همراه یک فرد دارای سن
                قانونی سفر کنند.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-1 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                آیا نیاز به خرید بلیط اتوبوس برای کودکان زیر 2 سال هم وجود دارد؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                بلیط اتوبوس افراد زیر دو سال در صورتی که صندلی به آن‌ها تعلق
                نگیرد رایگان است ولی در صورتی که نیاز به استفاده از صندلی داشته
                باشید,می‌بایست هزینه بلیط اتوبوس را کامل پرداخت نمایید.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-1 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                آیا قیمت یا تخفیف ویژه ای برای بلیط اتوبوس کودکان در نظر گرفته شده است؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                مسافران جوان ما که هنوز تولد 15 سالگی خود را جشن نگرفته اند ,با
                قیمت های کمتری با ما سفر می کنند. اگر در زمان خرید شما قیمت بلیط
                آنلاین ما ارزان تر از بلیط کودک باشد ,ما به طور خودکار این قیمت
                پایین تر را به شما ارائه می دهیم زیرا همیشه در تلاشیم بهترین
                قیمت را پیشنهاد دهیم.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Accordion className="mt-2 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                در صورت دیر رسیدن آیا اتوبوس منتظر من خواهد ماند؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                متاسفانه اتوبوس نمی تواند منتظر مسافران که دیر میرسند باشد.
                اتوبوس های ما در یک شبکه حرکت می کنند و به یک جدول زمانی محدود
                می شوند. لطفاً اطمینان حاصل کنید که حداقل 15 دقیقه قبل از حرکت
                در ایستگاه هستید.
                <br />
                اگر متوجه شدید که قرار نیست در زمان مناسب خود را به ایستگاه
                برسانید ,می توانید تا 30 دقیقه قبل از حرکت اتوبوس از طریق سایت
                یا اپلیکیشن ایباس ,بلیط خود را لغو کنید.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-2 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                امکان حمل حیوانات خانگی در اتوبوس وجود دارد؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                طبق قوانین سازمان حمل‌ونقل امکان حمل حیوانات زنده در اتوبوس وجود
                ندارد.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-1 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                جهت سوار شدن به اتوبوس چه مدت قبل از حرکت در ترمینال حضور داشته
                باشیم؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                15 دقیقه قبل از حرکت اتوبوس خود را به ایستگاه مورد نظر برسانید.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-1 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                چگونه می توانم بلیط اتوبوسم را استرداد کنم؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                در صورت قابل استرداد بودن بلیط خریداری شده,در «پنل کاربری» از
                منوی «سفارشات و استردادها»,سفارش مورد نظر را انتخاب کنید؛ بعد
                از کلیک بر روی گزینه استرداد و تکمیل مراحل,بلیط مورد نظر طبق
                قوانین و مقررات استرداد می‌شود. هزینه‌ای که مسترد می‌شود به همان
                شماره حسابی واریز می‌شود که خرید انجام شده است. اگر لازم است که
                هزینه مسترد شده به حساب دیگری واریز گردد,باید با پشتیبانی تماس
                گرفته و آن‌ها را در جریان بگذارید.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-1 mb-5 p-1">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HelpOutlineOutlinedIcon
                className="mr-4"
                style={{ color: "green" }}
                fontSize="large"
              />
              <Typography className={classes.heading}>
                میزان بار مجاز برای هر مسافر چقدر است؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.des}>
                طبق قوانین سازمان حمل‌ونقل میزان بار مجاز 20 کیلوگرم است.
                <br />
                اگر میزان بار اضافه شما بیش از حد باشد,می‌توانید در این مورد
                صحبت کنید که هزینه میزان بار اضافه‌تان را پرداخت کنید تا بتوانید
                همه وسیله‌هایتان را با خودتان حمل کنید.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </TabPanel>
      </div>
      <div className="row mt-3 container">
        <div className="col-12 col-md-6" style={{ paddingTop: "4.5rem" }}>
          <FontSizeH2
            style={{
              marginBlock: "5px 13px",
            }}
          >
            {" "}
            <b>بلیط اتوبوس</b>
          </FontSizeH2>
          <p
            style={{
              fontSize: "14px",
              marginBlock: "5px 50px",
              textAlign: "justify",
              lineHeight: "30px",
            }}
          >
            ایباس اولین سامانه حمل و نقل هوشمند بین شهری است. که فعالیت خود را
            از سال 1400 با هدف بهبود خدمات ارائه شده به مسافران آغاز کرده است.
            Ebus بهترین قیمت بلیط های بین شهری را ارائه می دهد و شما می توانید
            قیمت بلیط های ایباس را با سایر شرکت های فروش بلیط مقایسه کنید .
          </p>
          <h2
            style={{
              marginBlock: "5px",
            }}
            className="mt-2"
          >
            {" "}
            <b> خرید بلیط اینترنتی اتوبوس از ایباس</b>
          </h2>
          <p
            style={{
              fontSize: "14px",
              marginBlock: "13px 50px",
              textAlign: "justify",
              lineHeight: "30px",
            }}
          >
            با خرید بلیط اتوبوس از ایباس اطمینان خواهید داشت که از یک شرکت معتبر
            (که تمام مجوز های لازم در این حوزه را اخذ کرده است) بلیط خود را
            خریداری کرده اید و کارشناسان و پشتیبانان ما آماده پاسخگویی به شما
            خواهند بود. نحوه تهیه بلیط اینترنتی از ایباس بسیار ساده است. کافی
            است که مبدا حرکت اتوبوس و مقصد آن را مشخص و سپس تاریخ حرکت خود را
            انتخاب کنید و در نهایت بر روی دکمه جستجو کلیک کنید تا لیست قیمت بلیط
            برای مقصد شما نمایش داده شود . در این لیست گزینه های مختلفی برای
            محدود کردن قیمت بلیط اتوبوس ها و رسیدن به بهترین گزینه برای خرید
            بلیط برای شما مهیا شده است . سامانه رزرو بلیط اتوبوس ایباس امکانات
            زیادی دارد. می توانید صندلی مورد نظرتان را انتخاب کنید,اگر بلیط
            تهیه کرده اید و برنامه تان تغییر کرده یا از سفر کردن منصرف شده اید،
            می توانید بدون هیچ جریمه ای بلیط خود را لغو کنید. در هر شرایطی
            اتوبوس های ایباس به موقع و بدون هیچ تاخیری حرکت خواهند کرد پس اگر
            اهل برنامه ریزی هستید با خیال راحت بلیط خود را خریداری کنید. از همه
            مهم تر EBUS در مناسبت ها و شرایط مختلف تخفیفات و برنامه های ویژه ای
            برای شما در نظر گرفته است که با دنبال کردن صفحات اجتماعی ایباس می
            توانید زودتر از بقیه از آن ها مطلع شوید و سفری به صرفه,هیجان انگیز
            و در عین حال با آرامش را تجربه کنید
          </p>
        </div>
        <div className="col-12 col-md-6 d-flex align-items-center justify-content-center">
          <img
            src={descimg}
            width="100%"
            height="100%"
            alt="desc"
            style={{ objectFit: "contain" }}
          />
        </div>
      </div>

      <FontSizeH2
        style={{
          marginBlock: "15px 10px",
        }}
        className="mt-2 container"
      >
        {" "}
        <b>استرداد بلیط اتوبوس یا کنسلی بلیط </b>
      </FontSizeH2>
      <p
        style={{
          fontSize: "14px",
          marginBlock: "13px 50px",
          textAlign: "justify",
          lineHeight: "30px",
        }}
        className="container"
      >
        ایباس شرایط و قوانینی را فراهم کرده که شما بتوانید بلیط اتوبوس خریداری
        شده خود را لغو کنید .مبلغ بلیط شما بدون هیچ کسری به کیف پول خودتان در
        پنل کاربری ایباس بازمی گردد تا بتوانید بلیط بعدی خود را به راحتی تهیه
        کنید. برای اطلاع دقیق تر از قانون استرداد بلیط اینترنتی اتوبوس به قوانین
        استرداد بلیط مراجعه کنید .
      </p>
      <h2
        style={{
          marginBlock: "20px 5px",
        }}
        className="mt-2 container"
      >
        {" "}
        <b> رزرو بلیط اتوبوس </b>
      </h2>
      <p
        style={{
          fontSize: "14px",
          marginBlock: "13px 50px",
          textAlign: "justify",
          lineHeight: "30px",
        }}
        className="container"
      >
        در هفت روز هفته می توانید بلیط اتوبوس خود را رزرو کنید و مطمئن باشید که
        به صرفه ترین قیمت بلیط همراه با بهترین امکانات رفاهی را رزرو کرده اید .
        مسافرینی که از سایت ایباس و اپلیکیشن به صورت اینترنتی اقدام به تهیه بلیط
        اتوبوس می کنند در طول سفر از خدمات مطلوب رفاهی بهره مند خواهند شد. تیم
        خدمات مشتریان ایباس صبورانه در کنار شما خواهند بود تا سفری خاطره انگیز
        را برایتان به ارمغان بیاورند.
      </p>
      <h2
        style={{
          marginBlock: "20px 5px",
        }}
        className="mt-2 container"
      >
        {" "}
        <b> خرید بلیط اتوبوس VIP </b>
      </h2>
      <p
        style={{
          fontSize: "14px",
          marginBlock: "13px 10rem",
          textAlign: "justify",
          lineHeight: "30px",
        }}
        className="container"
      >
        اتوبوس های vip امروزه به دلیل ارائه خدمات بهتر دارای متقاضیان زیادی برای
        سفر هستند ,بلیط اتوبوس vip را می توانید از سایت ایباس خریداری کنید.
        ایباس با در اختیار داشتن بهترین اتوبوس های VIP موجود در بازار ایران،
        کیفیت سفر شما را تضمین میکند. قیمت بلیط اتوبوس vip در ایباس به صرفه ترین
        قیمت می باشد و به راحتی می توانید اقدام به خرید بلیط اتوبوس vip کنید .
        اتوبوس های وی ای پی دارای این امکانات رفاهی هستند : 1- صندلی های راحت 2-
        سیستم تهویه گرمایشی و سرمایشی 3- مانیتور شخصی با موزیک و فیلم 4- پذیرایی
        از مسافران 5- سرعت و امنیت بالا 6-شارژر رایگان سایت بلیط اتوبوس ایباس
        سعی دارد همواره بهترین خدمات را به مشتریان خود ارائه دهد و در این راستا
        از هیچ کاری دریغ نخواهد کرد . ایباس متخصص سفر جاده ای است و شرکتی مشابه
        آن در ایران وجود ندارد. ایباس متعهد است با هوشمند سازی و دخیل کردن
        تکنولوژی برای اولین بار در سیستم حمل و نقل جاده ای,تجربه ی متفاوتی از
        سفر جاده ای را برای شما رقم بزند.
      </p>
    </div>
  );
};

export default MainPageFaq;
